import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import FeedPage from "../Components/Feed/feed";

const Feed = () => {
  return (
    <div>
      <Navbar />
      <FeedPage />
      <Footer />
    </div>
  );
};

export default Feed;
